<template>
    <v-tab-item :value="UWSS.value">
        <section class="sub-section">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- F1Security develops and provides the prevention, detection,
                    and responding products against web hacking -->
                    {{ settings.product.uwss.first }}
                </h3>

                <div class="bg-grey radius-lg w-100 pa-16 pa-md-70 mb-40 mb-lg-80">
                    <v-img class="tb mx-auto mb-28 mb-lg-60" max-width="961" src="/images/sub/products/uwss/s1-img1-en.png"></v-img>
                    <v-img class="mo mx-auto mb-28 mb-lg-60" max-width="511" src="/images/sub/products/uwss/s1-img1-mo-en.png"></v-img>
                    <v-img class="tb mx-auto" max-width="961" src="/images/sub/products/uwss/s1-img2-en.png"></v-img>
                    <v-img class="mo mx-auto" max-width="510" src="/images/sub/products/uwss/s1-img2-mo-en.png"></v-img>
                </div>

                <div class="w-100 d-flex flex-column flex-lg-row radius dep2-process-group dep2-process-group1 mb-28 mb-lg-40">
                    <div class="dep2-process dep2-process1 d-lg-flex align-center justify-center pa-16 pa-md-32 py-lg-40">
                        <div>
                            <p class="font-size-14 font-size-lg-18 font-weight-bold color-white line-height-1 mb-6 mb-lg-14">
                                Issues
                            </p>
                            <p class="page-text color-white">
                                Being difficult for customers to select a product
                                for solving web security, and 
                                increasing system complexity
                            </p>
                        </div>
                    </div>
                    <div class="dep2-process-arrow d-flex align-center justify-center bg-grey py-16 py-lg-0">
                        <v-img class="d-block" max-width="38" src="/images/sub/products/uwss/process-arrow.png"></v-img>
                    </div>
                    <div class="dep2-process dep2-process2 pa-16 pa-md-32 pl-lg-60 py-lg-40">
                        <div>
                            <p class="color-point font-size-14 font-size-lg-18 font-weight-bold line-height-1 mb-6 mb-lg-14">
                                How to solve
                            </p>
                            <p class="page-text color-grey-57">
                                Enables customers to adopt <br class="d-none d-lg-block"/>
                                a wide range of essential web <br class="d-none d-lg-block"/>
                                security with only a single <br class="d-none d-lg-block"/>
                                UWSS service choice.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="w-100 d-flex flex-column flex-lg-row radius dep2-process-group dep2-process-group2 mb-28 mb-lg-40">
                    <div class="dep2-process dep2-process1 d-lg-flex align-center justify-center pa-16 pa-md-32 py-lg-40">
                        <div>
                            <p class="font-size-14 font-size-lg-18 font-weight-bold color-white line-height-1 mb-6 mb-lg-14">
                                Issues
                            </p>
                            <p class="page-text color-white">
                                The reality is that many
                                organizations lack the expertise
                                and experience of web security.
                            </p>
                        </div>
                    </div>
                    <div class="dep2-process-arrow d-flex align-center justify-center bg-grey py-16 py-lg-0">
                        <v-img class="d-block" max-width="38" src="/images/sub/products/uwss/process-arrow.png"></v-img>
                    </div>
                    <div class="dep2-process dep2-process2 pa-16 pa-md-32 pl-lg-60 py-lg-40">
                        <div>
                            <p class="color-point font-size-14 font-size-lg-18 font-weight-bold line-height-1 mb-6 mb-lg-14">
                                How to solve
                            </p>
                            <p class="page-text color-grey-57">
                                The need for operation <br class="d-none d-lg-block"/>
                                management using the intuitive <br class="d-none d-lg-block"/>
                                UI of the cloud central <br class="d-none d-lg-block"/>
                                management system
                            </p>
                        </div>
                    </div>
                </div>

                <div class="w-100 d-flex flex-column flex-lg-row radius dep2-process-group dep2-process-group3 mb-28 mb-lg-40">
                    <div class="dep2-process dep2-process1 d-lg-flex align-center justify-center pa-16 pa-md-32 py-lg-40">
                        <div>
                            <p class="font-size-14 font-size-lg-18 font-weight-bold color-white line-height-1 mb-6 mb-lg-14">
                                Issues
                            </p>
                            <p class="page-text color-white">
                                The cost is too high for most companies 
                                that desperately need to adopt 
                                a web security product.
                            </p>
                        </div>
                    </div>
                    <div class="dep2-process-arrow d-flex align-center justify-center bg-grey py-16 py-lg-0">
                        <v-img class="d-block" max-width="38" src="/images/sub/products/uwss/process-arrow.png"></v-img>
                    </div>
                    <div class="dep2-process dep2-process2 pa-16 pa-md-32 pl-lg-60 py-lg-40">
                        <div>
                            <p class="color-point font-size-14 font-size-lg-18 font-weight-bold line-height-1 mb-6 mb-lg-14">
                                How to solve
                            </p>
                            <p class="page-text color-grey-57">
                                It can be introduced with a <br class="d-none d-lg-block"/>
                                reasonable price system based <br class="d-none d-lg-block"/>
                                on software & cloud
                            </p>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>

        <section class="sub-section bg-grey">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- UWSS provides a variety of values to customers with differentiating factors -->
                    {{ settings.product.uwss.second }}
                </h3>

                <div class="client-table">
                    <div class="thead d-none d-lg-block">
                        <div class="tr">
                            <div class="th">Customer value</div>
                            <div class="th color-point">Differentiating factors</div>
                            <div class="th">Similar Product</div>
                        </div>
                    </div>
                    <div class="tbody">
                        <div class="tr">
                            <div class="td">
                                Integrated service
                            </div>
                            <div class="td ">
                                <span class="d-block d-lg-none">Differentiating factors</span>
                                Providing a comprehensive solution for the integrated operational management of Web security <br>
                                ※ Customized service based on customer choice
                            </div>
                            <div class="td">
                                <span class="d-block d-lg-none">Similar Product</span>
                                Buying each individual product, decreased convenience due to individual product management
                            </div>
                        </div>
                        <div class="tr">
                            <div class="td">
                                Reduction of server building cost
                            </div>
                            <div class="td ">
                                <span class="d-block d-lg-none">Differentiating factors</span>
                                Building and providing an integrated central management platform in the cloud <br>
                                ※ Zero customer server construction/operation cost
                            </div>
                            <div class="td">
                                <span class="d-block d-lg-none">Similar Product</span>
                                Management server purchase, construction, and operation cost incurred
                            </div>
                        </div>
                        <div class="tr">
                            <div class="td">
                                Immediate installation and operation
                            </div>
                            <div class="td ">
                                <span class="d-block d-lg-none">Differentiating factors</span>
                                Immediately available after downloading/installing the Agent 
                                software
                            </div>
                            <div class="td">
                                <span class="d-block d-lg-none">Similar Product</span>
                                SECaaS (Proxy type) requires time such as 
                                DNS change/application
                            </div>
                        </div>
                        <div class="tr">
                            <div class="td">
                                Operational and
                                management efficiency
                            </div>
                            <div class="td ">
                                <span class="d-block d-lg-none">Differentiating factors</span>
                                Integrated operation and management possible through 
                                a single website for management <br>
                                ※ Contract/manage multiple products with a single window (work efficiency improvement)
                            </div>
                            <div class="td">
                                <span class="d-block d-lg-none">Similar Product</span>
                                Providing individual product management system
                            </div>
                        </div>
                        <div class="tr">
                            <div class="td">
                                User-friendliness
                            </div>
                            <div class="td ">
                                <span class="d-block d-lg-none">Differentiating factors</span>
                                Increased security management convenience through integrated dashboard, integrated report, etc.
                            </div>
                            <div class="td">
                                <span class="d-block d-lg-none">Similar Product</span>
                                Not provided, individual product dashboard/report
                            </div>
                        </div>
                        <div class="tr">
                            <div class="td">
                                Ensuring Web access
                                in the event of a failure
                            </div>
                            <div class="td ">
                                <span class="d-block d-lg-none">Differentiating factors</span>
                                No impact on customer web access due to platform and 
                                agent failures
                            </div>
                            <div class="td">
                                <span class="d-block d-lg-none">Similar Product</span>
                                SECaaS (Proxy type) interrupts customer website access in case of service infrastructure failure
                            </div>
                        </div>
                        <div class="tr">
                            <div class="td">
                                Secure platform in
                                case of a hacking
                                incident
                            </div>
                            <div class="td ">
                                <span class="d-block d-lg-none">Differentiating factors</span>
                                Since the cloud platform does not bypass or store any web traffic, no information leakage occurs even if the platform is hacked.
                            </div>
                            <div class="td">
                                <span class="d-block d-lg-none">Similar Product</span>
                                <div class="bar-txt">
                                    - SECaaS (Proxy type) analyzes/stores all web traffic bypass in the service infrastructure (possible)
                                </div>
                                <div class="bar-txt">
                                    - Traffic information can be leaked in case of infrastructure failure
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- Provides web security and cloud central management system 
                    as One Platform One Service -->
                    {{ settings.product.uwss.third }}
                </h3>

                <p class="w-100 bg-point color-white text-center font-weight-bold font-size-16 font-size-lg-22 line-height-1 pa-18">
                    Web security service
                </p>
 
                <v-row no-gutters class="mb-40 mb-lg-80">
                    <v-col cols="12" lg="4" class="service-item">
                        <div class="d-flex flex-column align-center justify-center py-24 px-16">
                            <div class="bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14" style="width: 70px; height: 70px;">
                                <v-img class="d-block" max-width="46" src="/images/sub/products/uwss/s3-icon1-1.png"></v-img>
                            </div>
                            <p class="font-size-16 font-size-lg-16 font-size-xl-20 text-center line-height-1 font-weight-700">
                                Web Firewall
                            </p>
                        </div>
                        <div class="service-item-option pa-16 bg-grey">
                            <p class="color-point font-size-14 font-size-lg-18 line-height-1 text-center">
                                Software Agent
                            </p>
                        </div>
                        <div class="pa-16 pa-lg-34">
                            <p class="page-text-sm color-grey-49 bar-txt mb-10 mb-lg-24">
                                - OWASP Top 10 Web Application Attack Detection and Blocking   
                                  ※ Detection Only mode, Blocking mode can be selected
                            </p>
                            <p class="page-text-sm color-grey-49 bar-txt">
                                - Write user-defined rules, handle IP/Domain exceptions, Parameter Block
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4" class="service-item">
                        <div class="d-flex flex-column align-center justify-center py-24 px-16">
                            <div class="bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14" style="width: 70px; height: 70px;">
                                <v-img class="d-block" max-width="46" src="/images/sub/products/uwss/s3-icon1-2.png"></v-img>
                            </div>
                            <p class="font-size-16 font-size-lg-16 font-size-xl-20 text-center line-height-1 font-weight-700">
                                Anti-Web Shell
                            </p>
                        </div>
                        <div class="service-item-option pa-16 bg-grey">
                            <p class="color-point font-size-14 font-size-lg-18 line-height-1 text-center">
                                Software Agent
                            </p>
                        </div>
                        <div class="pa-16 pa-lg-34">
                            <p class="page-text-sm color-grey-49 bar-txt mb-10 mb-lg-24">
                                - Web shell detection and isolation (more than 3,500 detection patterns)  
                                  ※ Detecting Regex, Hash, Url, SSDeep, obfuscation algorithm application
                            </p>
                            <p class="page-text-sm color-grey-49 bar-txt">
                                - Real-time detection on/off, manual inspection settings, whitelist registration
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4" class="service-item">
                        <div class="d-flex flex-column align-center justify-center py-24 px-16">
                            <div class="bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14" style="width: 70px; height: 70px;">
                                <v-img class="d-block" max-width="46" src="/images/sub/products/uwss/s3-icon1-3.png"></v-img>
                            </div>
                            <p class="font-size-16 font-size-lg-16 font-size-xl-20 text-center line-height-1 font-weight-700">
                                Detecting web malware distribution
                            </p>
                        </div>
                        <div class="service-item-option pa-16 bg-grey">
                            <p class="color-point font-size-14 font-size-lg-18 line-height-1 text-center">
                                Remote Scanning
                            </p>
                        </div>
                        <div class="pa-16 pa-lg-34">
                            <p class="page-text-sm color-grey-49 bar-txt mb-10 mb-lg-24">
                                - Detection of URLs passing through and distributing malicious codes <br>
                                (more than 175,500 detection patterns)
                            </p>
                            <p class="page-text-sm color-grey-49 bar-txt">
                                - Periodic and manual inspection settings, Path Depth/Sub Page Link/Navigation Page settings
                            </p>
                        </div>
                    </v-col>
                </v-row>

                <p class="w-100 bg-point color-white text-center font-weight-bold font-size-16 font-size-lg-22 line-height-1 pa-18">
                    Central Management system
                </p>
 
                <v-row no-gutters class="service-item-group_option1">
                    <v-col cols="12" lg="3" class="service-item">
                        <div class="d-flex flex-column align-center justify-center py-24 px-16">
                            <div class="bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14" style="width: 70px; height: 70px;">
                                <v-img class="d-block" max-width="48" src="/images/sub/products/uwss/s3-icon2-1.png"></v-img>
                            </div>
                            <p class="font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700">
                                Settings
                            </p>
                        </div>
                        <div class="service-item-option pa-16 bg-grey">
                            <p class="color-point font-size-14 font-size-lg-18 line-height-1 text-center">
                                Cloud
                            </p>
                        </div>
                        <div class="pa-16 pa-lg-34">
                            <p class="page-text-sm color-grey-49 bar-txt">
                                - Agent download, registration, inquiry and change of security policy
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="3" class="service-item">
                        <div class="d-flex flex-column align-center justify-center py-24 px-16">
                            <div class="bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14" style="width: 70px; height: 70px;">
                                <v-img class="d-block" max-width="48" src="/images/sub/products/uwss/s3-icon2-2.png"></v-img>
                            </div>
                            <p class="font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700">
                                Integrated service
                            </p>
                        </div>
                        <div class="service-item-option pa-16 bg-grey">
                            <p class="color-point font-size-14 font-size-lg-18 line-height-1 text-center">
                                Cloud
                            </p>
                        </div>
                        <div class="pa-16 pa-lg-34">
                            <p class="page-text-sm color-grey-49 bar-txt">
                                - Integrated dashboard view, integrated report view and download
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="3" class="service-item">
                        <div class="d-flex flex-column align-center justify-center py-24 px-16">
                            <div class="bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14" style="width: 70px; height: 70px;">
                                <v-img class="d-block" max-width="48" src="/images/sub/products/uwss/s3-icon2-3.png"></v-img>
                            </div>
                            <p class="font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700">
                                Notifications
                            </p>
                        </div>
                        <div class="service-item-option pa-16 bg-grey">
                            <p class="color-point font-size-14 font-size-lg-18 line-height-1 text-center">
                                Cloud
                            </p>
                        </div>
                        <div class="pa-16 pa-lg-34">
                            <p class="page-text-sm color-grey-49 bar-txt">
                                - History of security events such as detection, blocking, and quarantine, etc. logging, and real-time email notifications
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="3" class="service-item">
                        <div class="d-flex flex-column align-center justify-center py-24 px-16">
                            <div class="bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14" style="width: 70px; height: 70px;">
                                <v-img class="d-block" max-width="48" src="/images/sub/products/uwss/s3-icon2-4.png"></v-img>
                            </div>
                            <p class="font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700">
                                My page
                            </p>
                        </div>
                        <div class="service-item-option pa-16 bg-grey">
                            <p class="color-point font-size-14 font-size-lg-18 line-height-1 text-center">
                                Cloud
                            </p>
                        </div>
                        <div class="pa-16 pa-lg-34">
                            <p class="page-text-sm color-grey-49 bar-txt">
                                - Inquiry, registration and change of user, service type, billing information, etc.
                            </p>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </v-tab-item>
</template>

<script>
import { PRIVATE_SALES_EN_TABS } from "@/assets/variables";
const { UWSS } = PRIVATE_SALES_EN_TABS;
import api from "@/api"
export default {
    data() {
        return {
            UWSS,
            settings: null,
            filter: {
                code: "en"
            }
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            const { settings } = await api.v1.boards.settings.get({
                headers: this.filter
            })
            this.settings = settings[0]
        }
    }
};
</script>

<style scoped>
    .dep2-process-group {
        border-radius: var(--radius);
        border: 1px solid var(--border-color-light);
    }

    .dep2-process{
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .dep2-process1{
        background-position: left center;
        overflow: hidden;
    }

    .dep2-process2{
        background-position: right center;
        border-left: 0;
        overflow: hidden;
    }

    .dep2-process-arrow{
        width: 100%;
        border: 0;
        border: 1px solid var(--border-color-light);
        border-left: 0;
        border-right: 0;
    }

    .dep2-process-arrow .v-image{
        transform: rotate(90deg);
    }

    .dep2-process-group1 .dep2-process1{
        background-image: url(/images/sub/products/uwss/s2-img1-1.png);
    }

    .dep2-process-group1 .dep2-process2{
        background-image: url(/images/sub/products/uwss/s2-img1-2.png);
    }

    .dep2-process-group2 .dep2-process1{
        background-image: url(/images/sub/products/uwss/s2-img2-1.png);
    }

    .dep2-process-group2 .dep2-process2{
        background-image: url(/images/sub/products/uwss/s2-img2-2.png);
    }

    .dep2-process-group3 .dep2-process1{
        background-image: url(/images/sub/products/uwss/s2-img3-1.png);
    }

    .dep2-process-group3 .dep2-process2{
        background-image: url(/images/sub/products/uwss/s2-img3-2.png);
    }

    .service-item-option{
        border-top: 1px solid var(--border-color-light);
        border-bottom: 1px solid var(--border-color-light);
    }

    .service-item{
        border-bottom: 1px solid var(--border-color-light);
    }

    @media (min-width:576px){
    }
    @media (min-width:768px){
    }
    @media (min-width:1024px){
        .client-table .td{
            padding: 45px 40px;
        }
        .dep2-process-group {
            border-radius: 0;
            border: 0;
        }
        .service-item>div:last-child{
            min-height: 180px;
        }

        .service-item:not(:last-child){
            border-right: 1px solid var(--border-color-light);
        }

        .service-item-group_option1{
            position: relative;
        }

        .service-item-group_option1::after{
            content: "Cloud";
            width: 100%;
            padding: 16px;
            background-color: #f4f7fb;
            color: var(--v-primary-base);
            font-size: 1.8rem;
            line-height: 1;
            text-align: center;
            border-top: 1px solid var(--border-color-light);
            border-bottom: 1px solid var(--border-color-light);
            display: block;
            position: absolute;
            left: 0;
            top: 154px;
        }

        .dep2-process1{
            border-radius: var(--radius) 0 0 var(--radius);
        }

        .dep2-process2{
            border-radius: 0 var(--radius) var(--radius) 0;
            border: 1px solid var(--border-color-light);
        }

        .dep2-process{
            width: calc((100% - 60px) / 2);
        }

        .dep2-process-arrow{
            width: 60px;
            border: 1px solid var(--border-color-light);
        }

        .dep2-process-arrow .v-image{
            transform: rotate(0);
        }

        .dep2-process1>div{
            width: 100%;
            max-width: 260px;
        }

    }
    @media (min-width:1200px){
    }

</style>
